(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews-filters"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const swiper = new Swiper('.review-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    loop: false,
    centeredSlides: false,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 3
      }
    }
  });

  const filterButtons = document.querySelectorAll('.review-filters button');
  const slides = document.querySelectorAll('.swiper-slide');

  filterButtons.forEach(button => {
    button.addEventListener('click', () => {
      const filter = button.getAttribute('data-filter');
      filterButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      slides.forEach(slide => {
        const card = slide.querySelector('.review-card');
        const cardFilters = card.getAttribute('data-filters').split(',');
        if (filter === 'all' || cardFilters.includes(filter)) {
          slide.style.display = 'block';
        } else {
          slide.style.display = 'none';
        }
      });

      swiper.update();
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
